export default __webpack_public_path__ + "static/media/c28fd6dfd4dd5466e903d6d23e36b5071581602522545.6bc33cf6.webp";